(function() {
    'use strict';

    angular.module('user')
        .controller('LoginController', LoginController);

    LoginController.$inject = [];

    function LoginController() {}
})();
